import { Metadata } from "next";
import AdminPaymentSubscriptionHistory from "@/Component/Admin/AdminPlan/AdminPaymentSubscriptionHistory";

export const metadata: Metadata = {
    title: "Subscription History | Connector Club",
    description: "",
};

const SubscriptionHistoryPage = () => {
    return (
        <AdminPaymentSubscriptionHistory />
    )
}

export default SubscriptionHistoryPage
